import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Icon from './icon/Icon';

const PriceSuffix = ({ onClickFunc, suffixText, showInfoIcon, mobileView }) => {
	return (
		// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
		<div
			className={classNames({
				pointerOnHover: !!onClickFunc,
				bestMonthlyPayment: !!onClickFunc,
			})}
			onClick={() => {
				if (onClickFunc) {
					onClickFunc();
				}
			}}>
			<span
				style={{
					display: 'flex',
					alignItems: 'center',
					margin: 0,
					marginLeft: '0.75rem',
					marginRight: '0.5rem',
					fontWeight: '300',
					fontSize: mobileView ? '1rem' : '',
				}}>
				{'  '}
				{suffixText}
				{showInfoIcon && (
					<Icon
						className='pointerOnHover'
						icon='InfoOutline'
						color='info'
						styles={{ marginLeft: '0.4rem', marginRight: '0.1rem' }}
					/>
				)}
			</span>
		</div>
	);
};

PriceSuffix.propTypes = {
	onClickFunc: PropTypes.func.isRequired,
	suffixText: PropTypes.string.isRequired,
	showInfoIcon: PropTypes.bool,
	mobileView: PropTypes.bool,
};

PriceSuffix.defaultProps = {
	mobileView: false,
	showInfoIcon: true,
};

export default PriceSuffix;
